module.exports = __webpack_public_path__ + "static/img/OBJECTS.ae946dda.png";